<template>
  <v-app>
    <router-view v-slot="{ Component, route }">
      <component :is="Component" :key="route" />
    </router-view>
  </v-app>
</template>

<script setup lang="ts">
import { useSeoMeta } from '@unhead/vue'

useSeoMeta({
  ogType: 'website',
  twitterCard: 'summary_large_image',
})
</script>
